import { QueryFilterKey } from "@/types/ai";
export var MentionType;
(function (MentionType) {
    MentionType["Segment"] = "segment";
    MentionType["User"] = "user";
})(MentionType || (MentionType = {}));
// Keeping those as numbers as long as we don't officially switch to "follow-up mode"
export var QnAPanelViewTab;
(function (QnAPanelViewTab) {
    QnAPanelViewTab[QnAPanelViewTab["Question"] = 0] = "Question";
    QnAPanelViewTab[QnAPanelViewTab["FollowUp"] = 1] = "FollowUp";
    QnAPanelViewTab[QnAPanelViewTab["Verbatims"] = 2] = "Verbatims";
    QnAPanelViewTab[QnAPanelViewTab["History"] = 3] = "History";
    QnAPanelViewTab[QnAPanelViewTab["HistoryFollowUp"] = 4] = "HistoryFollowUp";
    QnAPanelViewTab[QnAPanelViewTab["HistoryVerbatims"] = 5] = "HistoryVerbatims";
})(QnAPanelViewTab || (QnAPanelViewTab = {}));
export var SourcesSortOption;
(function (SourcesSortOption) {
    SourcesSortOption["MostRelevant"] = "mostRelevant";
    SourcesSortOption["MostRecent"] = "mostRecent";
    SourcesSortOption["Oldest"] = "oldest";
})(SourcesSortOption || (SourcesSortOption = {}));
